module.exports = __webpack_public_path__ + "static/assets/c83c5b739c000eb8e99ff589510d5642.png";